import React from 'react';
import './contactus.css';

import mapimage from "../../assets/images/Loc.jpg"

const ContactUs = () => {
  return (
    <div className="contact-us">
      <h1>Contact Us</h1>
      <div className="contact-info">
        <p>
          Dr. Maryam Fatima, Shalamar Medical &amp; Dental College, Shalimar Link Road, Mughalpura, Lahore, Pakistan
        </p>
        <p>
          Email: <a href="mailto:conference@smdc.edu.pk">conference@smdc.edu.pk</a>
        </p>
        <p>
          Email: <a href="mailto:maryam.fatima@sihs.org.pk">maryam.fatima@sihs.org.pk</a>
        </p>
        <p>Tel: +92 42 3685 2660</p>
        <p>FAX: +92 42 3683 5555</p>
        <p>
          Website: <a href="http://www.smdc.edu.pk" target="_blank" rel="noopener noreferrer">www.smdc.edu.pk</a>
        </p>
        <p className="technical-assistance">
          For Technical Assistance Please Dial +92 334 876 1004 OR +92 111 205 205 Ext. 566
        </p>
      </div>
      <div className="map-container">
        <img src={mapimage} alt="Map Location" />
      </div>
    </div>
  );
};

export default ContactUs;
